export default __webpack_public_path__ + "static/media/APACHE RR 310_5.aeb697da.webp";